import { Command } from 'commands/Commands';

export class Delete extends Command {
    type: string = 'BlogArticle.Delete';
    constructor(public id: string) {
        super(null, id);
    }
    priority: number = 200;
}
